import { render, staticRenderFns } from "./FranchiseDirectoryPagination.vue?vue&type=template&id=6d022fb8&scoped=true&"
import script from "./FranchiseDirectoryPagination.vue?vue&type=script&lang=js&"
export * from "./FranchiseDirectoryPagination.vue?vue&type=script&lang=js&"
import style0 from "./FranchiseDirectoryPagination.vue?vue&type=style&index=0&id=6d022fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d022fb8",
  null
  
)

export default component.exports